import { article as articleData } from "shared/data/article";

export const getTypeValue = (typeId: string) => {
  switch (typeId) {
    case articleData.types.chinaFutureTechBriefing.entityId:
      return 2;
    case articleData.types.column.entityId:
    case articleData.types.opinion.entityId:
      return 4;
    case articleData.types.factSheet.entityId:
      return 1;
    case articleData.types.infographic.entityId:
      return 3;
    default:
      return 5;
  }
};

export const getParsedHtml = (html: string) =>
  html.replaceAll(/<a\s+href="([^"]*)"/g, (match: string, hrefContent: string) => {
    const scmpUrl = "https://www.scmp.com";
    const isScmpLink = hrefContent.startsWith(scmpUrl);

    if (isScmpLink) {
      const url = new URL(hrefContent);
      const parameters = new URLSearchParams(url.search);
      parameters.set("module", "inline");
      parameters.set("pgtype", "agenda");
      const newHref = `${url.pathname}?${parameters.toString()}`;
      return match.replace(hrefContent, newHref);
    } else {
      return match.replace("<a ", '<a target="_blank" ');
    }
  });
